import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import type { AiImageEditPageComponent } from 'ai-features/components/ai-image-edit-page/ai-image-edit-page.component';
import { AuthenticationService } from 'authentication/services/authentication.service';

export const aiImageEditPageLeaveGuard: CanDeactivateFn<AiImageEditPageComponent> = (component) =>
    inject(AuthenticationService).isForceLogout || component.canLeave();
